import * as Constants from 'const';
import * as Models from 'models';
import { BrandFontRef } from '../brandFont';

// We have pretty the same util function on BE
export function getBrandFontRefFromBrandStyle(
  brandStyle: Models.BrandStyleObjMap,
  brandFonts: Models.BrandFontsList,
): BrandFontRef | undefined {
  const fontName = brandStyle.get(Models.BrandStyleProp.FONT_FAMILY);

  if (fontName.startsWith(Constants.EXTERNAL_REF_KEY)) {
    const [fontFamilyId, charStyleId] = fontName.split(Constants.ID_START_KEY)[1].split(Constants.ID_SEPARATOR_KEY);
    const brandFont = brandFonts.find((font: Models.BrandFontMap) => font.get('id') === fontFamilyId);
    if (!brandFont) {
      return undefined;
    }

    const brandCharStyle = brandFont.get('characterStyles')?.find(charStyle => charStyle?.get('id') === charStyleId);

    return {
      fontName: brandFont.get('name'),
      characterStyleName: brandCharStyle?.get('name'),
    };
  }

  return { fontName, characterStyleName: undefined };
}
